module.exports = __webpack_public_path__ + "static/media/clock-clockwise.2a525764.svg";